/**
 * Array of spotlight properties
 * @typedef {string[]} properties
 */

/**
 * //TODO probably this should live somewhere else (maybe a lib)
 * UPshow feature
 * @typedef {string} feature
 */

/**
 * Array of organization features
 * @typedef {feature[]} features
 */

/**
 * BOH Data Type
 * @typedef {string} data_type
 */

/**
 * Array of data types
 * @typedef {data_type[]} data_types
 */

/**
 * Object mapping different BOH spotlight types to their corresponding feature keys.
 */
const BOH_FEATURE_BY_SPOTLIGHT_PROPERTY = {
  boh_type_training_course: 'spotlight_boh_training_course',
  boh_type_customer_comments: 'spotlight_boh_customer_comments',
  boh_type_location_avg_ticket: 'spotlight_boh_avg_tickets',
  boh_type_avg_check_size: 'spotlight_boh_avg_check_size',
  boh_type_shift_log: 'spotlight_boh_shift_log',
  boh_type_nps: 'spotlight_boh_nps',
  boh_type_acr_by_store: 'spotlight_boh_acr_by_store',
  boh_type_drive_thru_sos: 'spotlight_boh_drive_thru_sos',
  boh_type_store_speed_of_service: 'spotlight_boh_store_speed_of_service',
  boh_type_huddle_board: 'spotlight_boh_huddle_board',
  boh_type_product_sales_leaderboard: 'spotlight_product_sales_leaderboard',
  boh_type_thermometer_sales: 'spotlight_boh_thermometer_sales',
  boh_type_same_store_sales: 'spotlight_boh_same_store_sales',
  boh_type_avg_guest_spend: 'spotlight_boh_avg_guest_spend',
  boh_type_product_sales_by_store: 'spotlight_boh_product_sales_by_store',
  boh_type_percentage_to_goal: 'spotlight_boh_percentage_to_goal',
  boh_type_bio: 'spotlight_boh_bio',
  boh_type_employee_highlight: 'spotlight_boh_employee_highlight',
  boh_type_blazin_by_store: 'spotlight_blazin_by_store',
  boh_type_blazin_attachment: 'spotlight_blazin_attachment',
  boh_type_training_by_store: 'spotlight_training_by_store',
  boh_type_birthday: 'spotlight_boh_birthday',
  boh_type_anniversary: 'spotlight_boh_anniversary',
  boh_type_multi_birthday: 'spotlight_boh_multi_birthday',
  boh_type_multi_anniversary: 'spotlight_boh_multi_anniversary',
  boh_type_employee_loyalty_leaderboard: 'spotlight_boh_employee_loyalty_leaderboard',
  boh_type_huddle_notes: 'spotlight_boh_huddle_notes',
  boh_type_employee_shoutout: 'spotlight_boh_shoutout',
  boh_type_birthday_single_employee: 'spotlight_boh_birthday_single_employee',
  boh_type_anniversary_single_employee: 'spotlight_boh_anniversary_single_employee',
  boh_type_payday: 'spotlight_boh_payday',
  boh_type_product_highlight: 'spotlight_boh_product_highlight',
  boh_type_metrics_dashboard: 'spotlight_boh_metrics_dashboard',
  boh_type_poll: 'spotlight_boh_poll'
};

/**
 *  Array of spotlight types that don't require BOH data from the API.
 */
const BOH_SPOTLIGHT_WITHOUT_DATA = ['boh_type_huddle_notes', 'boh_type_employee_highlight', 'boh_type_bio', 'boh_type_employee_shoutout', 'boh_type_charity', 'boh_type_cleaning', 'boh_type_birthday_single_employee', 'boh_type_anniversary_single_employee', 'boh_type_product_highlight'];

/**
 *  Array of spotlight types that don't require feature.
 */
const BOH_SPOTLIGHTS_WITHOUT_FEATURE = ['boh_type_charity', 'boh_type_cleaning'];

/**
 *  Array of features that require a boh_store_id.
 */
const BOH_FEATURES_REQUIRING_BOH_STORE_ID = ['boh_contests'];
for (const spt_property in BOH_FEATURE_BY_SPOTLIGHT_PROPERTY) {
  if (!BOH_SPOTLIGHT_WITHOUT_DATA.includes(spt_property)) {
    BOH_FEATURES_REQUIRING_BOH_STORE_ID.push(BOH_FEATURE_BY_SPOTLIGHT_PROPERTY[spt_property]);
  }
}

/**
 *  Array of all the features related to BOH
 */
const BOH_FEATURES = ['boh_spotlights', 'boh_contests', 'boh_employee_bulk'].concat(Object.values(BOH_FEATURE_BY_SPOTLIGHT_PROPERTY));

/**
 * Object with key BOH Data Type and value an Array of it's associated BOH feature
 */
const DATA_TYPE_FEATURES = {
  TRAINING: ['spotlight_boh_training_course', 'spotlight_training_by_store'],
  COMMENTS: ['spotlight_boh_customer_comments'],
  SOS: ['spotlight_boh_drive_thru_sos', 'spotlight_boh_store_speed_of_service', 'spotlight_boh_huddle_board'],
  POS: ['spotlight_boh_avg_check_size', 'spotlight_boh_avg_tickets', 'spotlight_product_sales_leaderboard', 'spotlight_boh_thermometer_sales', 'spotlight_boh_same_store_sales', 'spotlight_boh_avg_guest_spend', 'spotlight_boh_product_sales_by_store', 'spotlight_boh_percentage_to_goal'],
  NPS: ['spotlight_boh_nps', 'spotlight_boh_huddle_board', 'spotlight_boh_metrics_dashboard', 'spotlight_boh_acr_by_store'],
  LOYALTY: ['spotlight_blazin_by_store', 'spotlight_blazin_attachment', 'spotlight_boh_employee_loyalty_leaderboard'],
  EMPLOYEES: ['spotlight_boh_birthday', 'spotlight_boh_anniversary', 'spotlight_boh_multi_birthday', 'spotlight_boh_multi_anniversary']
};

/**
 * Array of Data Types
 * @type {data_types}
 */
const DATA_TYPES = Object.keys(DATA_TYPE_FEATURES);

/**
 * Array of Data Providers
 * @type {string[]}
 */
const DATA_PROVIDERS = ['SELF_PROVIDED', 'XENIAL', 'ALOHA', 'EPSILON', 'INSPIRE', 'BKC', 'PARTECH', 'MANUAL_PROVIDER', 'TIM_HORTONS', 'SCHOOX', 'R365', 'PAROPS', 'QU', 'ORACLE'];

/**
 * Object with key BOH feature and value it's associated Data Type
 */
const FEATURES_DATA_TYPES = DATA_TYPES.reduce((acc, data_type) => {
  DATA_TYPE_FEATURES[data_type].forEach(feature => {
    if (acc[feature]) {
      acc[feature].push(data_type);
    } else {
      acc[feature] = [data_type];
    }
  });
  return acc;
}, {});

/**
 * Returns true if it has the boh feature
 * @param {features} features
 * @return {boolean}
 */
const hasBOHFeature = features => features.includes('boh_spotlights');

/**
 * Returns true if the spotlight is a boh spotlight
 * @param {properties} properties
 * @returns {boolean}
 */
const isBOHSpotlight = properties => properties.includes('boh_spotlight');

/**
 * Returns true if all required features for a given BOH spotlight type are met
 * @param {string} property
 * @param {features} features
 * @returns {boolean}
 */
const hasBOHFeatureForSpotlightType = (property, features) => features.includes('boh_spotlights') && (BOH_SPOTLIGHTS_WITHOUT_FEATURE.includes(property) || features.includes(BOH_FEATURE_BY_SPOTLIGHT_PROPERTY[property]));

/**
 * Returns the property that represents the spotlight type for BOH
 * @param {properties} properties
 * @returns {string}
 */
const getBOHSpotlightType = properties => properties.find(prop => prop.startsWith('boh_type_'));

/**
 * Returns true if the spotlight requires BOH Data from the API
 * @param {properties} properties
 * @returns {boolean}
 */
const requiresBOHData = properties => {
  if (!isBOHSpotlight(properties)) return false;
  return !BOH_SPOTLIGHT_WITHOUT_DATA.includes(getBOHSpotlightType(properties));
};

/**
 * Returns true if any of the features given require BOH Store Id
 * @param {features} features
 * @returns {boolean}
 */
const hasFeaturesRequiringBOHStoreId = features => features.some(f => BOH_FEATURES_REQUIRING_BOH_STORE_ID.includes(f));

/**
 * Returns true if the spotlight is BOH and has a missing feature
 * @param {features} features
 * @param {properties} properties
 * @returns {boolean}
 */
const isBOHSpotlightWithoutFeature = (features, properties = []) => {
  if (!isBOHSpotlight(properties)) return false;
  if (!features.includes('boh_spotlights')) return true;
  return !hasBOHFeatureForSpotlightType(getBOHSpotlightType(properties), features);
};

/**
 * Returns true if spotlight is valid BOH spotlight
 * @param {properties} properties
 * @param {features} features
 * @param {string} boh_store_id
 * @returns {boolean}
 */
const isValidBOHSpotlight = (properties, features, boh_store_id) => {
  if (isBOHSpotlightWithoutFeature(features, properties)) return false;
  const bohType = getBOHSpotlightType(properties);
  const isPoll = bohType === 'boh_type_poll';
  if (requiresBOHData(properties) && !isPoll && !boh_store_id) return false;
  return true;
};

/**
 * Returns warnings given a set of features and data_types
 * @param {features} features
 * @param {data_types} data_types
 * @param {string} boh_store_id
 * @return {*[]}
 */
const shiftWarnings = (features, data_types, boh_store_id) => {
  if (!hasBOHFeature(features)) {
    if (data_types.length > 0) return [{
      code: 20,
      message: 'Organization has at least one Data provider configured but boh_spotlights feature flag is missing.',
      severity: 1
    }];
    return [];
  }
  if (!boh_store_id && hasFeaturesRequiringBOHStoreId(features)) return [{
    code: 17,
    message: 'Missing BOH Store Id',
    severity: 1
  }];
  const warnings = [];
  for (const data_type of data_types) {
    if (!DATA_TYPES.includes(data_type)) {
      warnings.push({
        code: 21,
        severity: 3,
        message: `Invalid Data Type ${data_type}`
      });
      continue;
    }
    const associatedFeatureToDataType = DATA_TYPE_FEATURES[data_type];
    const hasFeatureForDataType = features.some(feature => associatedFeatureToDataType.includes(feature));
    if (!hasFeatureForDataType) {
      // If we have this data type, and we don't have a corresponding feature
      warnings.push({
        code: 18,
        severity: 2,
        message: `No feature flags enabled for [${data_type}] Data. Expected feature flags: ${associatedFeatureToDataType.join(', ')}.`
      });
    }
  }
  for (const feature of features) {
    const requiredDataType = FEATURES_DATA_TYPES[feature];
    if (!requiredDataType) continue;
    if (!requiredDataType.some(requiredDataType => data_types.includes(requiredDataType))) {
      const formattedDatatype = requiredDataType.map(type => `[${type}]`);
      warnings.push({
        code: 19,
        severity: 2,
        message: `No data types configured for [${feature}]. Expected data types: ${formattedDatatype.join(', ')}.`
      });
    }
  }
  return warnings;
};

/**
 * Returns true if the organization has access to the spotlight PLU group or PLU family
 *
 * @param {object} metadata
 * @param {[]} orgSettings
 * @returns {boolean}
 */
const hasAccessToGroupOrFamily = (metadata, orgSettings) => {
  const {
    boh_plu_group,
    boh_contest_id,
    boh_product_family
  } = metadata;
  if (boh_contest_id) return true;
  if (boh_plu_group) {
    return !!orgSettings.find(({
      key
    }) => key.includes(`boh.plu.group.${boh_plu_group}`));
  }
  if (boh_product_family) {
    return !!orgSettings.find(({
      key
    }) => key.includes(`boh.product.family.${boh_product_family}`));
  }
  return true;
};
const BOH_DEFAULT_GOALS_VALUES = {
  'boh.goals.overall_satisfaction': 0.9,
  'boh.goals.order_accuracy': 0.9,
  'boh.goals.likelihood_to_return': 0.9,
  'boh.goals.speed_of_service_score': 0.9,
  'boh.goals.sales_thermometer_all_days': 1000,
  'boh.goals.sales_thermometer_monday': 1000,
  'boh.goals.sales_thermometer_tuesday': 1000,
  'boh.goals.sales_thermometer_wednesday': 1000,
  'boh.goals.sales_thermometer_thursday': 1000,
  'boh.goals.sales_thermometer_friday': 1000,
  'boh.goals.sales_thermometer_saturday': 1000,
  'boh.goals.sales_thermometer_sunday': 1000,
  'boh.goals.units_thermometer_all_days': 10,
  'boh.goals.units_thermometer_monday': 10,
  'boh.goals.units_thermometer_tuesday': 10,
  'boh.goals.units_thermometer_wednesday': 10,
  'boh.goals.units_thermometer_thursday': 10,
  'boh.goals.units_thermometer_friday': 10,
  'boh.goals.units_thermometer_saturday': 10,
  'boh.goals.units_thermometer_sunday': 10,
  'boh.goals.tickets_thermometer_all_days': 50,
  'boh.goals.tickets_thermometer_monday': 50,
  'boh.goals.tickets_thermometer_tuesday': 50,
  'boh.goals.tickets_thermometer_wednesday': 50,
  'boh.goals.tickets_thermometer_thursday': 50,
  'boh.goals.tickets_thermometer_friday': 50,
  'boh.goals.tickets_thermometer_saturday': 50,
  'boh.goals.tickets_thermometer_sunday': 50,
  'boh.goals.loyalty_all_days': 80,
  'boh.goals.loyalty_monday': 80,
  'boh.goals.loyalty_tuesday': 80,
  'boh.goals.loyalty_wednesday': 80,
  'boh.goals.loyalty_thursday': 80,
  'boh.goals.loyalty_friday': 80,
  'boh.goals.loyalty_saturday': 80,
  'boh.goals.loyalty_sunday': 80,
  'boh.goals.sales_thermometer_all_days_flag': {
    key: 'boh.goals.sales_thermometer_all_days_flag',
    value: true,
    reset: false
  },
  'boh.goals.units_thermometer_all_days_flag': {
    key: 'boh.goals.units_thermometer_all_days_flag',
    value: true,
    reset: false
  },
  'boh.goals.tickets_thermometer_all_days_flag': {
    key: 'boh.goals.tickets_thermometer_all_days_flag',
    value: true,
    reset: false
  },
  'boh.goals.loyalty_is_all_days_flag': {
    key: 'boh.goals.loyalty_is_all_days_flag',
    value: true,
    reset: false
  }
};
module.exports = {
  BOH_DEFAULT_GOALS_VALUES,
  BOH_SPOTLIGHT_WITHOUT_DATA,
  BOH_FEATURE_BY_SPOTLIGHT_PROPERTY,
  BOH_FEATURES_REQUIRING_BOH_STORE_ID,
  BOH_FEATURES,
  DATA_PROVIDERS,
  DATA_TYPES,
  DATA_TYPE_FEATURES,
  FEATURES_DATA_TYPES,
  hasBOHFeatureForSpotlightType,
  requiresBOHData,
  hasFeaturesRequiringBOHStoreId,
  isBOHSpotlightWithoutFeature,
  isValidBOHSpotlight,
  getBOHSpotlightType,
  isBOHSpotlight,
  hasBOHFeature,
  shiftWarnings,
  hasAccessToGroupOrFamily
};